import cloneDeep from 'lodash/cloneDeep';
import { App, FeatureToggles } from '@ps20-frontend/frontend-models';
import { AnyAction, Reducer } from 'redux';
import {
  GlobalAction,
  GlobalActions,
  isAzam,
  ProduktDeleted,
  ReplaceState,
  WrappedSavedStates,
  WrappedSavedStatesLoaded,
} from '@ps20-frontend/shop-integration-redux';
import { Zahlungsart } from '@ps20/bff-models';
import {
  migrateAktionsnachlassAktion10, migrateAngebotsdatum,
} from '@ps20-frontend/migrations';
import { IAppState } from '../appState';
import { INITIAL_STATE } from '../initialState';
import { loadAndMigrateGegeState } from '../migrations';

export const rootReducer =
  (reducer: Reducer) =>
  (state: IAppState, action: AnyAction): IAppState => {
    switch (action.type) {
      case GlobalActions.REPLACE_STATE: {
        const actionPayload: ReplaceState<IAppState> = action.payload;
        if (actionPayload.appId === App.GEGE && actionPayload.angebotsId === state.angebotsId) {
          return actionPayload.appState;
        }
        return state;
      }
      case GlobalActions.ANGEBOTS_ID_RECEIVED: {
        return {
          ...state,
          angebotsId: action.payload,
        };
      }
      case GlobalActions.SAVED_STATES_LOADED: {
        const newState = cloneDeep(state);
        const actionPayload: WrappedSavedStates = (action as GlobalAction<WrappedSavedStatesLoaded>)
          .payload.savedStatesLoaded;
        const loadedAppState = actionPayload.find(
          loadedState =>
            loadedState.appId === App.GEGE && loadedState.angebotsId === state.angebotsId,
        );
        if (loadedAppState != null) {
          if (
            isAzam(newState.transientState.role) &&
            newState.vertragsoptionen?.zahlungsart === Zahlungsart.MAKLER_INKASSO
          ) {
            delete loadedAppState.state.vertragsoptionen.zahlungsart;
          }
          migrateAngebotsdatum(loadedAppState.state);
          migrateAktionsnachlassAktion10(
            loadedAppState.state,
            newState.transientState.featureToggles as FeatureToggles,
          );
          return loadAndMigrateGegeState(
            newState,
            loadedAppState.state,
            loadedAppState.state.vertragsoptionen?.beibehalten,
          );
        } else {
          return state;
        }
      }
      case GlobalActions.PRODUKT_DELETED: {
        const actionPayload: ProduktDeleted = action.payload;
        if (
          actionPayload.angebotsIds.some(
            angebotsId =>
              angebotsId.appId === App.GEGE && angebotsId.angebotsId === state.angebotsId,
          )
        ) {
          const newState: IAppState = cloneDeep(INITIAL_STATE);
          newState.vertragsoptionen.zahlungsweise = state.vertragsoptionen.zahlungsweise;
          newState.vertragsoptionen.zahlungsart = state.vertragsoptionen.zahlungsart;

          newState.versicherungsnehmer.geburtsdatum = state.versicherungsnehmer.geburtsdatum;
          newState.versicherungsnehmer.isAssekuranztarif =
            state.versicherungsnehmer.isAssekuranztarif;
          newState.transientState.role = state.transientState.role;

          newState.gegenstandsschutz.categories = state.gegenstandsschutz.categories;

          return newState;
        }
        return state;
      }
      default:
        return reducer(state, action);
    }
  };
